/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Coinvestment_Emailtemplate2Inputs */

const en_settings_coinvestment_emailtemplate2 = /** @type {(inputs: Settings_Coinvestment_Emailtemplate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email template`)
};

/**
* | output |
* | --- |
* | "Email template" |
*
* @param {Settings_Coinvestment_Emailtemplate2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_coinvestment_emailtemplate2 = /** @type {((inputs?: Settings_Coinvestment_Emailtemplate2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Coinvestment_Emailtemplate2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_coinvestment_emailtemplate2(inputs)
});
export { settings_coinvestment_emailtemplate2 as "settings_coInvestment_emailTemplate" }